export const ACCESS_TOKEN = "access_token";
export const REFRESH_TOKEN = "refresh_token";
export const REFRESH_TOKEN_URL = "/api/auth/refresh-token";
export const USER_INFO = "user_info";
